import { STEPS } from "@/data/content";
import { Reveal, Eyebrow } from "./Reveal";

export const Process = () => (
  <section id="ablauf" data-testid="process-section" className="border-y border-white/10 bg-[var(--deep)]">
    <div className="mx-auto max-w-[1400px] px-5 py-24 sm:px-8 sm:py-32">
      <Reveal><Eyebrow>Ablauf</Eyebrow></Reveal>
      <Reveal delay={0.08}><h2 className="mt-6 max-w-3xl font-display text-4xl sm:text-5xl lg:text-6xl font-semibold leading-[1] tracking-[-0.03em]">Vom Check zur Inbetriebnahme.</h2></Reveal>
      <ol className="mt-16 grid gap-px overflow-hidden rounded-[28px] border border-white/10 bg-white/10 sm:grid-cols-2 lg:grid-cols-4">
        {STEPS.map((s, i) => (
          <Reveal as="li" key={s.n} delay={i * 0.08} className="group bg-[var(--deep)] p-8 transition-colors duration-500 hover:bg-[#0A2E33]">
            <div data-testid={`process-step-${s.n}`}>
              <span className="font-display text-6xl font-semibold text-outline transition-colors duration-500 group-hover:text-[var(--lagoon)]">{s.n}</span>
              <h3 className="mt-10 font-display text-2xl font-medium tracking-[-0.02em]">{s.title}</h3>
              <p className="mt-3 text-sm sm:text-base text-[var(--mist)]">{s.text}</p>
            </div>
          </Reveal>
        ))}
      </ol>
    </div>
  </section>
);
